import React, { useState } from 'react';
import logo from "../images/logo.png";
import { Lock, Eye, EyeOff } from 'lucide-react';
import MultiAcessoService from '../../modules/services/MultiAcessoService';
import '../css/login.css';

const SENHA_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[*.+():_=\-@#!$])[A-Za-z\d*.+():_=\-@#!$]{6,15}$/;
const REGRA_SENHA = 'A senha deve ter entre 6 e 15 caracteres, com ao menos uma letra maiúscula, uma minúscula, um número e um caractere especial (*.+():_=-@#!$).';

const TEXTOS_POR_MOTIVO = {
    'primeiro-acesso': {
        titulo: 'Defina sua nova senha.',
        descricao: 'Este é o seu primeiro acesso — antes de continuar, você precisa trocar a senha temporária.',
    },
    expirada: {
        titulo: 'Sua senha expirou.',
        descricao: 'Sua senha venceu (validade de 90 dias) — antes de continuar, defina uma nova senha.',
    },
};

/**
 * RN007: troca obrigatória de senha no primeiro acesso, e também quando a senha expira (90
 * dias) — mesma tela, só o texto muda conforme `motivo` ('primeiro-acesso' | 'expirada').
 * Bloqueia o fluxo até a senha ser trocada com sucesso — não há como pular ou fechar esta tela.
 */
function TrocarSenha({ onSucesso, motivo }) {
    const textos = TEXTOS_POR_MOTIVO[motivo] || TEXTOS_POR_MOTIVO['primeiro-acesso'];
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!SENHA_REGEX.test(novaSenha)) {
            setErro(REGRA_SENHA);
            return;
        }
        if (novaSenha !== confirmarSenha) {
            setErro('As senhas não coincidem.');
            return;
        }

        setErro('');
        setCarregando(true);
        try {
            await MultiAcessoService.trocarSenhaPrimeiroAcesso(novaSenha);
            onSucesso();
        } catch (error) {
            setErro(error.message || 'Não foi possível atualizar a senha.');
        } finally {
            setCarregando(false);
        }
    };

    return (
        <main className="login-page">
            <aside className="login-brand-panel">
                <div className="login-brand-mark">
                    <span className="login-wordmark">
                        <img src={logo} alt="Logo" className="logo" />
                    </span>
                </div>
                <div className="login-brand-headline">
                    <h1>{textos.titulo}</h1>
                    <p>{textos.descricao}</p>
                </div>
            </aside>

            <section className="login-form-panel">
                <div className="login-form-wrap">
                    <div className="login-form-header">
                        <h2>Trocar senha</h2>
                        <p>{REGRA_SENHA}</p>
                    </div>

                    <form className="login-form" onSubmit={handleSubmit} noValidate>
                        <div className="login-field">
                            <label htmlFor="nova-senha">Nova senha</label>
                            <div className="login-input-wrap">
                                <Lock className="login-ico-lead" size={18} />
                                <input
                                    id="nova-senha"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={novaSenha}
                                    onChange={(event) => setNovaSenha(event.target.value)}
                                    disabled={carregando}
                                />
                                <button
                                    type="button"
                                    className="login-toggle-pwd"
                                    aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                                    onClick={() => setMostrarSenha((valor) => !valor)}
                                >
                                    {mostrarSenha ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>

                        <div className="login-field">
                            <label htmlFor="confirmar-senha">Confirmar nova senha</label>
                            <div className="login-input-wrap">
                                <Lock className="login-ico-lead" size={18} />
                                <input
                                    id="confirmar-senha"
                                    type={mostrarSenha ? 'text' : 'password'}
                                    value={confirmarSenha}
                                    onChange={(event) => setConfirmarSenha(event.target.value)}
                                    disabled={carregando}
                                />
                            </div>
                        </div>

                        {erro && <div className="login-erro">{erro}</div>}

                        <button type="submit" className="login-btn-submit" disabled={carregando}>
                            {carregando ? 'Salvando...' : 'Salvar nova senha'}
                        </button>
                    </form>
                </div>
            </section>
        </main>
    );
}

export default TrocarSenha;
